import { render, staticRenderFns } from "./CreditRating.vue?vue&type=template&id=c4815e30&scoped=true"
import script from "./CreditRating.vue?vue&type=script&lang=js"
export * from "./CreditRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4815e30",
  null
  
)

export default component.exports